import React, { Component } from 'react'
import animateScrollTo from 'animated-scroll-to'

import './styles/BubbleButtonStyles.css'

class BubbleButton extends Component {

    onClick() {
        const target = this.props.appRootView.refs['contactForm']
        if (target) {
            animateScrollTo(target.offsetTop,{
                onComplete: ()=>{

                }
            })
        }
        
    }

    render() {
        if (this.props.type === 'transparent') {
            return (
                <div className="BubbleButtonWrapperTransparent" onClick={this.props.onClick?this.props.onClick:this.onClick.bind(this)}>
                    <div className="BubbleButtonIconWrapperTransparent"></div>
                    <div className="BubbleButtonTitleWrapperTransparent">
                        {this.props.title}
                    </div>
                </div>
            )
        }

        if (this.props.type === 'orange') {
            return (
                <div className="BubbleButtonWrapperOrange" onClick={this.props.onClick?this.props.onClick:this.onClick.bind(this)}>
                <div className="BubbleButtonWrapperInner">
                    <div className="BubbleButtonIconWrapperOrange"></div>
                    <div className="BubbleButtonTitleWrapperOrange">
                        {this.props.title}
                    </div>
                </div>
            </div>
            )
        }        

        return (
            <div className="BubbleButtonWrapper" onClick={this.props.onClick?this.props.onClick:this.onClick.bind(this)}>
                <div className="BubbleButtonWrapperInner">
                    <div className="BubbleButtonIconWrapper"></div>
                    <div className="BubbleButtonTitleWrapper">
                        {this.props.title}
                    </div>
                </div>
            </div>
        )        

    }
}

export default BubbleButton


// WEBPACK FOOTER //
// ./src/Components/BubbleButton/BubbleButton.js